module.exports = __webpack_public_path__ + "media/headerBg.f4d5b923.mp4";